import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import ThriftyAdviceWrapper from "@components/layouts/thriftyAdviceWrapper";

export default function ContactUsHome(): ReactElement {
    return (
        <ThriftyAdviceWrapper fullMaxWidth>
            <div className="bg-white">
                <ContactTop iconsFillColor="#39a7ae" />
            </div>
            <FormSection iconsFillColor="black" />
        </ThriftyAdviceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
